var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0066 10.6104C24.0268 10.8049 24.0268 10.9947 24.0268 11.2034C24.0268 17.2748 19.1023 24.2854 10.0825 24.2854C7.30674 24.2854 4.73325 23.5312 2.54907 22.222C2.93838 22.2552 3.33275 22.2932 3.72206 22.2932C6.01747 22.2932 8.14098 21.558 9.81956 20.3152C7.67583 20.282 5.86579 18.9492 5.2338 17.1135C5.5321 17.1657 5.85062 17.1989 6.16409 17.1989C6.60902 17.1989 7.03878 17.1467 7.44831 17.0423C5.20852 16.6202 3.51476 14.7513 3.51476 12.5315L3.51476 12.4603C4.20238 12.8256 4.95066 13.02 5.73434 13.039C4.4299 12.2184 3.55521 10.8191 3.55521 9.20643C3.55521 8.36687 3.7979 7.57948 4.22766 6.89645C6.64947 9.67602 10.2493 11.5164 14.3345 11.7061C14.2587 11.3741 14.2031 11.0231 14.2031 10.6579C14.2031 8.12022 16.4024 6.05688 19.1074 6.05688C20.5231 6.05688 21.7921 6.61659 22.687 7.50833C23.7892 7.29963 24.851 6.92965 25.8015 6.38892C25.4476 7.47513 24.6639 8.36687 23.6578 8.94081C24.6437 8.81748 25.5942 8.57557 26.4739 8.2056C25.7964 9.14002 24.9723 9.94164 24.0066 10.6104Z",
    fill: "#1C9CEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.79a76e4f0b3b6d0ab18069a6e82829dc.svg";
export { ForwardRef as ReactComponent };